var _defs, _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_791",
    "data-name": "Group 791",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_955",
    "data-name": "Rectangle 955",
    width: 40,
    height: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_953",
    "data-name": "Rectangle 953",
    width: 5.161,
    height: 10.436,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M5.036.5H34.714A4.565,4.565,0,0,1,39.25,5.092V24.658a4.565,4.565,0,0,1-4.536,4.592H5.036A4.565,4.565,0,0,1,.5,24.658V5.092A4.565,4.565,0,0,1,5.036.5",
    transform: "translate(0.125 0.125)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M5.036.5H34.714A4.565,4.565,0,0,1,39.25,5.092V24.658a4.565,4.565,0,0,1-4.536,4.592H5.036A4.565,4.565,0,0,1,.5,24.658V5.092A4.565,4.565,0,0,1,5.036.5Z",
    transform: "translate(0.125 0.125)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M14.193,19.826A6.522,6.522,0,1,0,7.742,13.3a6.486,6.486,0,0,0,6.451,6.521",
    transform: "translate(1.936 1.696)",
    fill: "#e7001a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M20.387,19.826A6.522,6.522,0,1,0,13.936,13.3a6.486,6.486,0,0,0,6.451,6.521",
    transform: "translate(3.484 1.696)",
    fill: "#f49b1c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    transform: "translate(17.419 9.782)",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M16.516,7.826a6.565,6.565,0,0,1,0,10.436,6.565,6.565,0,0,1,0-10.436",
    transform: "translate(-13.936 -7.826)",
    fill: "#e7001a",
    fillRule: "evenodd"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.52f760dc9060fb15ea11ff3d25066ed4.svg";
export { ForwardRef as ReactComponent };